export interface MenuItem {
	title: string;
	url?: string;
	color?: string;
	icon?: string;
	children?: MenuItem[];
	expanded?: boolean;
}

export const MENU_ITEMS: MenuItem[] = [
	{
		title: 'Dashboard',
		url: '/dashboard',
		icon: 'home'
	},
	{
		title: 'Reports',
		icon: 'bar-chart',
		expanded: false,
		children: [
			{ title: 'Sales Report', url: '/reports/sales' },
			{ title: 'User Report', url: '/reports/users' }
		]
	},
	{
		title: 'Settings',
		icon: 'settings',
		expanded: false,
		children: [
			{ title: 'Profile', url: '/settings/profile' },
			{ title: 'Security', url: '/settings/security' }
		]
	}
];

export const PUBLIC_MENU_ITEMS: MenuItem[] = [{ title: 'Home', url: '/home', icon: 'fas fa-home' }];

export const LOGIN_MENU_ITEM: MenuItem[] = [{ title: 'Login', url: '/login', icon: 'fas fa-sign-in-alt' }];

export const LOGOUT_MENU_ITEM: MenuItem[] = [{ title: 'Logout', url: '/logout', icon: 'fas fa-sign-out-alt' }];

export const HELPDESK_MENU_ITEM: MenuItem[] = [{ title: 'Help Desk', url: '/help-desk', icon: 'fas fa-hands-helping' }];

export const SUPER_USER_MENU_ITEMS: MenuItem[] = [
	{
		title: 'Onboarding',
		url: '/management-committee',
		icon: 'far fa-plus-square'
	},
	{
		title: 'Invitation',
		url: '/invitation',
		icon: 'far fa-paper-plane'
	},
	// {
	//   title: 'Enquiry Management',
	//   url: 'enquiry-manangement',
	//   icon: 'server'
	// },
	{
		title: 'Activation',
		url: '/activation',
		icon: 'far fa-check-circle'
	},
	{
		title: 'Demo Enquiry',
		url: 'demo-enquiry',
		icon: 'fas fa-headset'
	},
	,
	{
		title: 'Help Desk',
		url: '/help-desk',
		icon: 'fas fa-hands-helping'
	}
];

export const IQAC_MENU_ITEMS: MenuItem[] = [
	{
		title: 'Invitation Management',
		url: '/invitation',
		icon: 'fas fa-paper-plane'
	},
	{
		title: 'Department Management',
		url: '/department-management',
		icon: 'fas fa-building'
	},
	{
		title: 'Committee Management',
		url: '/college-committte-mangement',
		icon: 'fas fa-object-group'
	},
	{
		title: 'Role Management',
		url: '/staff-management',
		icon: 'fas fa-users'
	},
	{
		title: 'College Type-Year Mapping',
		url: '/year-management',
		icon: 'fas fa-landmark'
	},
	{
		title: 'Download Reports',
		url: '/report',
		icon: 'fas fa-file'
	},
	{
		title: 'AQAR',
		url: '/aqar',
		icon: 'fas fa-clipboard-check'
	},
	{
		title: 'IQAC Inbox',
		url: '/iqac-dashboard',
		icon: 'fas fa-user-cog'
	}
];

export const IQAC_CO_ADMINMENU_ITEMS: MenuItem[] = [
	{
		title: 'Download Reports',
		url: '/report',
		icon: 'fas fa-file'
	},
	{
		title: 'IQAC Inbox',
		url: '/iqac-dashboard',
		icon: 'fas fa-user-cog'
	}
];

export const PERSONAL_INBOX_MENU: MenuItem[] = [
	{
		title: 'Personal Inbox',
		url: '/shared-form-inbox/undefined',
		icon: 'fa-solid fa-box',
		color: 'cadetblue'
	}
];

export const OFFICE_CO_MENU_ITEMS: MenuItem[] = [
	{
		title: 'Office Inbox',
		url: '/office-coordinator-dashboard',
		icon: 'fas fa-user-tie'
	}
];

export const LIBRARY_MENU_ITEMS: MenuItem[] = [
	{
		title: 'Library Inbox',
		url: '/library-knowledge-resources-dashboard',
		icon: 'fas fa-inbox'
	}
];

export const GREEN_MENU_ITEMS: MenuItem[] = [
	{
		title: 'Green Initiatives Inbox',
		url: '/green-initiatives-dashboard',
		icon: 'fa-solid fa-leaf'
	}
];

export const PHY_EDU_MENU_ITEMS: MenuItem[] = [
	{
		title: 'Physical Edu. & Sports Inbox',
		url: '/physical-education-and-sports-dashboard',
		icon: 'fa-solid fa-medal'
	}
];

export const ADMIN_MENU_ITEMS: MenuItem[] = [
	{
		title: 'Admin Dashboard',
		url: '/admin-dashboard',
		icon: 'fas fa-user-shield'
	}
];

export const WEB_CO_INBOX_MENU: MenuItem[] = [
	{
		title: 'Web Coordinator Inbox',
		url: '/web-coordinator-dashboard',
		icon: 'fa-brands fa-internet-explorer'
	}
];

export const FACILITATOR_INBOX_MENU: MenuItem[] = [
	{
		title: 'Facilitator Inbox',
		url: '/facilitator-dashboard',
		icon: 'fa-solid fa-handshake-angle'
	}
];

export const MY_PROFILE_MENU: MenuItem[] = [
	{
		title: 'My Profile',
		url: '/user-profile',
		icon: 'fa-regular fa-user'
	}
];
